import { mutatorAction } from 'satcheljs';
import { ClientItem, mailStore } from 'owa-mail-store';
import { logUsage } from 'owa-analytics';
import { CustomData } from 'owa-analytics-actions';

export default mutatorAction('setWrongLanguage', function setWrongLanguage(itemId: string) {
    const item: ClientItem = mailStore.items.get(itemId);
    item.TranslationData.isWrongLanguage = true;
    const customData: CustomData = item.TranslationData.isFastTextLanguage
        ? { fastText: true }
        : [];
    logUsage('InlineTranslationWrongLanguage', customData, {
        cosmosOnlyData: JSON.stringify({
            id: item.ItemId.Id,
            language: item.TranslationData.itemLocaleName,
        }),
    });
});
